import { useState } from "react";

import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';

import { Box, Button, Divider, IconButton, Tab, Tabs } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import { Add } from "@mui/icons-material";

import { AllProjects } from "../index";
import { useCapabilities } from "../../../hooks/useCapabilities";
import { useNavigation } from "../../../hooks/useNavigation";

export const Projects = () => {

    const { can } = useCapabilities();

    const isAllowedToAddProject = can("operational_delivery:project_manager:project:add");
    const { goToAddProject } = useNavigation();

    const [currentTab, setCurrentTab] = useState('all-projects');
    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    const tabs = [
        {
            value: 'all-projects',
            label: 'All PROJECTS',
            icon: <MenuIcon />,
        },
        {
            value: 'pinned',
            label: 'PINNED',
            icon: <BookmarksIcon />,
        },
        {
            value: 'my-view',
            label: 'MY VIEW',
        },
        {
            value: 'others',
            label: 'SOME OTHER LIST',
        }
    ];

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <TabContext value={currentTab}>
                <Box display="flex" alignItems="center" alignContent="center">
                    <Tabs
                        value={currentTab}
                        onChange={handleChangeTab}
                        aria-label="Tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{ minHeight: 'auto' }}
                    >
                        {tabs.map((t) => (
                            <Tab
                                key={t.value}
                                sx={{ height: 'auto', minHeight: 'auto' }}
                                label={t.label}
                                value={t.value}
                                iconPosition="start"
                                icon={t.icon || undefined}
                                disabled={t.value !== 'all-projects' && t.value !== 'pinned' ? true : false}
                            />
                        ))}
                        <IconButton>
                            <Add />
                        </IconButton>
                    </Tabs>
                    <Box px={2} ml={'auto'}>
                        {
                            isAllowedToAddProject && (
                                <Button startIcon={<Add />} onClick={goToAddProject}>
                                    ADD PROJECT
                                </Button>
                            )
                        }
                    </Box>
                </Box>
                <Divider />
                <Box flex={1} overflow="hidden" mt={2}>
                    <TabPanel value="all-projects" sx={{ p: 0, height: "100%" }}>
                        <AllProjects isPinned={false} />
                    </TabPanel>
                    <TabPanel value="pinned" sx={{ p: 0, height: "100%" }}>
                        <AllProjects isPinned={true} />
                    </TabPanel>
                    <TabPanel value="my-view" sx={{ p: 0, height: "100%" }}>
                        {/* <AllProjects /> */}
                    </TabPanel>
                    <TabPanel value="others" sx={{ p: 0, height: "100%" }}>
                        {/* <Others /> */}
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    )
}